import IRepo from "../../../common/interfaces/repo";
import Repo from "../../../common/state/modules/repo";
import TrackedModel from "../../../common/models/tracked/trackedModel";
import License from "./license";

export default class LicenseStatus extends TrackedModel{

  license: License;
  name: string;
  status_type: number;
  sort_order: number;

  static _defaultStatuses: LicenseStatus[] = [];

  static repo: IRepo<LicenseStatus> = new Repo<LicenseStatus>('license_statuses', LicenseStatus);

  constructor() {
    super();
    this.defineProperty('name', null);
    this.defineProperty('sort_order', null);
  }

  static get placeholderName() {
    return "Enter Status Name"
  }

  get rootName() {
    return 'license_statuses';
  }

  get vOption() {
    return {
      sortOrder: this.sort_order,
      label: this.name,
      value: this.client_id
    }
  }

  static get defaultStatuses() {
    if (this._defaultStatuses.length) {
      return this._defaultStatuses
    } else {
      this._defaultStatuses = [
        new LicenseStatus().loadFromJson({name: "Default 1", client_id: "abc", sort_order: 0}),
        new LicenseStatus().loadFromJson({name: "Default 2", client_id: "123", sort_order: 1})
      ]
    }
    return this._defaultStatuses;
  }

  static get defaultVOptions() {
    return this.defaultStatuses.map(x => {
      return x.vOption
    })
  }
}